<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//eslint-disable-next-line
import Suppliers from "../../../components/suppliers/suppliers.vue";
/**
 * Starter component
 */
import { adminComputed } from "@/state/helpers";
export default {
    page: {
        title: "Client Suppliers",
        meta: [{ name: "description", content: appConfig.description }],
    },
    //eslint-disable-next-line
    components: { Layout, PageHeader, Suppliers },
    // title: "Client Suppliers",
    data() {
        return {
            items: [
                // {
                //     text: "Collection List",
                //     href: "/collectionslist",
                // },
                // {
                //     text: "Client Suppliers",
                //     active: true,
                // },
            ],
        };
    },
    computed: {
        ...adminComputed,
        title() {
            if (this.user_role == "User") {
                return "Suppliers";
            }
            return "Client Suppliers";
        },
    },
    mounted() {},
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <Suppliers />
    </Layout>
</template>
